import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FileText, ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Qué recibiré al comprar este producto?',
  answer: 'Obtendrás acceso inmediato a un pack digital con más de 300 recetas exclusivas de café, té y postres gourmet para preparar desde casa. Además, incluye 7 bonus digitales premium: Guía de Métodos de Extracción del Café, Mitos y Verdades del Café, y la Guía Emprendedora: Mi Cafetería. Todo en formato PDF descargable, listo para disfrutar desde tu celular, tablet o computadora.'
}, {
  question: '¿Puedo leerlo en mi celular, tablet o computadora?',
  answer: '¡Por supuesto! El archivo PDF es 100% compatible con cualquier dispositivo. Podrás leerlo cómodamente desde tu celular, tablet, computadora o incluso imprimirlo si lo prefieres.'
}, {
  question: '¿Cuándo lo recibo?',
  answer: 'Inmediatamente después de tu compra. Verás un botón de descarga y también recibirás el enlace en tu correo electrónico. Te recomendamos revisar la carpeta de spam si no lo encuentras en tu bandeja principal.'
}, {
  question: '¿Qué pasa si tengo problemas para descargar?',
  answer: 'No te preocupes, estamos para ayudarte. Escríbenos a correo@gmail.com y te asistiremos lo antes posible para que puedas acceder a tu contenido sin inconvenientes.'
}, {
  question: '¿Necesito experiencia previa en café?',
  answer: 'No, para nada. Esta guía está diseñada para ser accesible tanto para principiantes como para quienes ya tienen experiencia. Todas las recetas incluyen cantidades exactas y pasos claros para que logres resultados profesionales desde el primer intento.'
}, {
  question: '¿Qué métodos de pago aceptan?',
  answer: 'Aceptamos múltiples formas de pago para tu comodidad: tarjetas de crédito y débito, PayPal, Apple Pay, Google Pay y Mercado Pago. Elige la opción que más te convenga.'
}];
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border-b border-coffee-light/20" data-id="element-38">
      <button onClick={onClick} className="w-full flex items-center gap-3 py-4 text-left" data-id="element-39">
        <FileText className="w-5 h-5 text-coffee/40 shrink-0" data-id="element-40" />
        <span className="flex-1 font-serif text-coffee-dark text-sm md:text-base" data-id="element-41">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-42">
          <ChevronDown className="w-5 h-5 text-coffee/40" data-id="element-43" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-44">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-45">
            <p className="pb-4 pl-8 pr-4 text-coffee/70 text-sm leading-relaxed" data-id="element-46">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 bg-cream" data-id="element-47">
      <div className="max-w-2xl mx-auto px-6" data-id="element-48">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-49">
          <h2 className="text-2xl md:text-3xl font-serif text-coffee-dark uppercase tracking-wide" data-id="element-50">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        {/* FAQ List */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-lg shadow-sm" data-id="element-51">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-52" />)}
        </motion.div>
      </div>
    </section>;
}